module.exports = __webpack_public_path__ + "static/media/filter_8_white_18dp.a53fc870.svg";